export default {
  PRE_SUBSCRIBE: 0,
  QUALIFYING: 1,
  APPLYING_CREDIT: 2,
  CREDIT_APPLIED: 3,
  DISQUALIFIED: 4,
};
